import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface StatusInfo {
    status: number;
    message: string;
}

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlingService {
    private statusSubject = new BehaviorSubject<{ [key: string]: StatusInfo }>({});
    status$ = this.statusSubject.asObservable();

    reportStatus(endpoint: string, status: number, message: string) {
        const currentStatus = this.statusSubject.value;
        currentStatus[endpoint] = { status, message };
        this.statusSubject.next(currentStatus);
    }

    clearStatus(endpoint: string) {
        const currentStatus = this.statusSubject.value;
        delete currentStatus[endpoint];
        this.statusSubject.next(currentStatus);
    }

    getStatus(endpoint: string): StatusInfo | undefined {
        return this.statusSubject.value[endpoint];
    }
}
